import React from "react";

export default function LandingPage() {
  return (
    <div className="container">
      <header>
        <h1>🚢 Helmsman.sh</h1>
        <p className="tagline">
          Prep for <strong>CKA</strong> & <strong>CKAD</strong> with real Kubernetes scenarios — gamified!
        </p>
      </header>

      <main>
        <a href="/game" className="btn-start">🎮 Enter the Challenge</a>
      </main>

      <footer>
        <p>Built for aspiring Kubernetes pros by cloud-native learners ⚓</p>
      </footer>
    </div>
  );
}
